export enum ChartType {
  AREA = "area",
  BAR = "bar",
  BIAXIAL = "biaxial",
  BOX_PLOT = "box_plot",
  COMPOSED = "composed",
  DONUT = "donut",
  FUNNEL = "funnel",
  LINE = "line",
  METRIC = "metric",
  NUMBER = "number",
  PIE = "pie",
  PROGRESS = "progress",
  SANKEY = "sankey",
  SCATTER = "scatter",
  STACKED_SIGN = "stacked_sign",
  TABLE = "table",
  TREEMAP = "treemap",
}
